export default function PolitiqueConfidentialite() {
  return (
    <section className="section">
      <div className="container" style={{ maxWidth: '780px' }}>

        <div data-aos="fade-up">
          <span className="eyebrow">Légal</span>
          <h1 className="fw-900 mt-3 display-5">Politique de confidentialité</h1>
          <p className="text-secondary mt-2" style={{ fontSize: '0.85rem' }}>
            Dernière mise à jour : juin 2026 &nbsp;·&nbsp; Conforme à la <strong>Loi 25</strong> du Québec
          </p>
        </div>

        <hr className="my-4" />

        {/* 1 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">1. Qui sommes-nous ?</h2>
          <p className="text-secondary mt-2">
            CPUc Solutions Technologiques inc. (<strong>« CPUc »</strong>) est une entreprise québécoise
            offrant des services informatiques aux cliniques dentaires et aux PME. Nous sommes responsables
            du traitement de vos renseignements personnels collectés via ce site.
          </p>
          <p className="text-secondary">
            <i className="bi bi-envelope me-2 text-brand"></i>
            <a href="mailto:info@cpucsolutions.com" className="text-brand">info@cpucsolutions.com</a>
            &emsp;
            <i className="bi bi-telephone me-2 text-brand"></i>
            <a href="tel:4184767088" className="text-brand">(418) 476-7088</a>
          </p>
        </div>

        {/* 2 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">2. Quels renseignements collectons-nous ?</h2>
          <p className="text-secondary mt-2">
            Nous collectons uniquement les renseignements que vous nous fournissez volontairement :
          </p>
          <ul className="text-secondary" style={{ lineHeight: 2 }}>
            <li>Nom et prénom</li>
            <li>Adresse courriel</li>
            <li>Numéro de téléphone</li>
            <li>Nom de votre entreprise</li>
            <li>Contenu de vos messages (formulaire de contact)</li>
          </ul>
          <p className="text-secondary">
            Nous collectons également des données techniques anonymisées via les cookies (voir section 5).
          </p>
        </div>

        {/* 3 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">3. Pourquoi collectons-nous ces renseignements ?</h2>
          <p className="text-secondary mt-2">Vos renseignements sont utilisés pour :</p>
          <ul className="text-secondary" style={{ lineHeight: 2 }}>
            <li>Répondre à vos demandes de contact ou de soumission</li>
            <li>Vous fournir nos services informatiques</li>
            <li>Améliorer l'expérience utilisateur sur notre site</li>
            <li>Respecter nos obligations légales</li>
          </ul>
          <p className="text-secondary">
            Nous ne vendons, n'échangeons et ne louons jamais vos renseignements personnels à des tiers.
          </p>
        </div>

        {/* 4 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">4. Conservation des données</h2>
          <p className="text-secondary mt-2">
            Vos renseignements sont conservés aussi longtemps que nécessaire pour les fins décrites
            dans cette politique, ou selon les exigences légales applicables. Les données de formulaire
            de contact sont conservées un maximum de <strong>24 mois</strong>.
          </p>
        </div>

        {/* 5 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">5. Cookies et technologies similaires</h2>
          <p className="text-secondary mt-2">
            Notre site utilise des cookies pour améliorer votre expérience. Conformément à la Loi 25,
            nous vous demandons votre consentement avant tout dépôt de cookies non essentiels.
          </p>

          <div className="row g-3 mt-1">
            <div className="col-md-6">
              <div className="service-card p-3 h-100">
                <p className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>
                  <i className="bi bi-shield-check text-brand me-2"></i>
                  Cookies essentiels
                </p>
                <p className="text-secondary small mb-0">
                  Nécessaires au fonctionnement du site. Toujours actifs — aucun consentement requis.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="service-card p-3 h-100">
                <p className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>
                  <i className="bi bi-bar-chart text-brand me-2"></i>
                  Cookies analytiques
                </p>
                <p className="text-secondary small mb-0">
                  Nous aident à comprendre comment le site est utilisé. Activés seulement avec votre consentement.
                </p>
              </div>
            </div>
          </div>

          <p className="text-secondary mt-3">
            Vous pouvez retirer votre consentement à tout moment en cliquant sur{' '}
            <button
              onClick={() => { localStorage.removeItem('cpuc_cookie_consent'); window.location.reload(); }}
              className="btn btn-sm btn-outline-brand rounded-pill px-3"
            >
              Gérer mes préférences
            </button>
          </p>
        </div>

        {/* 6 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">6. Vos droits (Loi 25)</h2>
          <p className="text-secondary mt-2">
            Conformément à la <em>Loi modernisant des dispositions législatives en matière de protection
            des renseignements personnels</em> (Loi 25), vous avez le droit de :
          </p>
          <ul className="text-secondary" style={{ lineHeight: 2 }}>
            <li><strong>Accéder</strong> aux renseignements personnels que nous détenons sur vous</li>
            <li><strong>Rectifier</strong> toute information inexacte</li>
            <li><strong>Retirer votre consentement</strong> au traitement de vos données</li>
            <li><strong>Demander la suppression</strong> de vos renseignements personnels</li>
            <li><strong>Déposer une plainte</strong> auprès de la Commission d'accès à l'information du Québec (CAI)</li>
          </ul>
          <p className="text-secondary">
            Pour exercer ces droits, contactez-nous à{' '}
            <a href="mailto:info@cpucsolutions.com" className="text-brand fw-bold">info@cpucsolutions.com</a>.
            Nous répondrons dans un délai de <strong>30 jours</strong>.
          </p>
        </div>

        {/* 7 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">7. Sécurité</h2>
          <p className="text-secondary mt-2">
            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées
            pour protéger vos renseignements contre tout accès non autorisé, divulgation, modification
            ou destruction — incluant le chiffrement des données en transit (HTTPS) et des accès restreints.
          </p>
        </div>

        {/* 8 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">8. Modifications de cette politique</h2>
          <p className="text-secondary mt-2">
            Nous nous réservons le droit de modifier cette politique en tout temps. Toute modification
            sera publiée sur cette page avec la date de mise à jour. Nous vous encourageons à la consulter
            périodiquement.
          </p>
        </div>

        {/* 9 */}
        <div className="mb-5" data-aos="fade-up">
          <h2 className="h5 fw-bold">9. Nous contacter</h2>
          <p className="text-secondary mt-2">
            Pour toute question relative à cette politique ou au traitement de vos renseignements :
          </p>
          <p className="text-secondary">
            <strong>CPUc Solutions Technologiques inc.</strong><br />
            <i className="bi bi-envelope me-2 text-brand"></i>
            <a href="mailto:info@cpucsolutions.com" className="text-brand">info@cpucsolutions.com</a><br />
            <i className="bi bi-telephone me-2 text-brand"></i>
            <a href="tel:4184767088" className="text-brand">(418) 476-7088</a>
          </p>
        </div>

        <hr className="my-4" />
        <p className="text-secondary small text-center mb-5">
          © {new Date().getFullYear()} CPUc Solutions Technologiques inc. — Tous droits réservés.
        </p>

      </div>
    </section>
  );
}